import { Component } from 'react';
import moment from 'moment';
import './footer.css';
import AppContext from '../app-context';


class Footer extends Component {
  static contextType = AppContext;
  render() {
    let translations = this.context.translations;
    return (
      <div className="footer">
        <span className='copyrightSpan'>&copy; {moment().format('YYYY')} Offer2Order</span>
        <nav className='footer-footerNavigation'>
          <ul>
            {/* <li>
              <a href="/">
                {translations['footer_contact']}
              </a>
            </li> */}
            <li>
              <a target="_blank" href="https://www.wicam.com/en/data-privacy-notice/">
                {translations['footer_data_privacy_notice']}
              </a>
            </li>
            <li>
              <a target="_blank" href="https://www.wicam.com/nl/impressum/">
                {translations['footer_imprint']}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default Footer;